<template>
  <div class="cropper-video-panel">
    <div class="panel-title">
      裁剪列表
    </div>
    <div
      v-if="dataList.length"
      class="video-content"
    >
      <div
        id="cropper-video-list"
        class="video-list"
      >
        <div
          v-for="(item, i) in dataList"
          :key="i"
          class="video-list-content"
        >
          <videoListItem
            :item="item"
            :index="i"
            @delClick="delItem"
          ></videoListItem>
        </div>
        <scrollContent :id-name="'cropper-video-list'"></scrollContent>
      </div>
      <div class="video-clear">
        <iconfont
          class="normal"
          name="#icon12-12shanchu"
          font-size="14px"
        ></iconfont>
        <iconfont
          class="hover"
          name="#icon12-12shanchujiaohu"
          font-size="14px"
          color="#2F58FE"
        ></iconfont>
        <span @click="clearList">清空列表</span>
      </div>
    </div>
    <div
      v-else
      class="panel-no-data"
    >
      还没有任何作品哦
    </div>
  </div>
</template>
<script>
export default {
  name: 'CropperVideoPanel',
  components: {
    VideoListItem: () => import('@/components/videoCutter/videoListItem'),
    ScrollContent: () => import('@/components/videoCutter/scrollContent')
  },
  data() {
    return {
      index: 1,
      dataList: []
    };
  },
  mounted() {
    this.$bus.on('taskSuccess.cropperMask', this.cropperSuccess);
    this.$bus.on('resetEditing', this.resetEditing);
  },
  beforeDestroy() {
    this.dataList = [];
    this.$store.commit('cropper/clearFiles');
    this.$bus.off('taskSuccess.cropperMask', this.cropperSuccess);
    this.$bus.on('resetEditing', this.resetEditing);
  },
  methods: {
    cropperSuccess(data) {
      let arr = data.name.split('.');
      arr.length > 1 && arr.pop();
      let name = arr.join('.');

      let item = {
        url: data.newkey,
        cover: data.thumbnailkey,
        name: `${name}(${this.index}).mp4`,
        duration: data.duration
      };
      this.index++;
      this.dataList.push(item);
      this.$store.commit('cropper/addFile', item);
    },
    delItem(index) {
      this.$modal.show('MessageDialog', {
        content: '是否确认删除该文件？',
        btns: ['Cancel', 'Ok', 'Close'],
        size: { width: 478, height: 184 },
        resultHandler: (value) => {
          if (!value) return;
          if (value && value.type == 'Ok') {
            this.dataList.splice(index, 1);
            this.$store.commit('cropper/deleteFile', index);
          }
        }
      });
    },
    clearList() {
      if (this.dataList.length) {
        this.$modal.show('MessageDialog', {
          content: '是否确定要清空当前的列表内容？（操作不可恢复）',
          size: { width: 478, height: 184 },
          btns: ['Cancel', 'Ok', 'Close'],
          resultHandler: (value) => {
            if (value && value.type == 'Ok') {
              this.dataList = [];
              this.$store.commit('cropper/clearFiles');
            }
          }
        });
      }
    },
    resetEditing() {
      this.dataList = [];
    }
  }
};
</script>
<style lang="scss" scoped>
.cropper-video-panel {
  width: 326px;
  height: 100%;
  background: #ffffff;
  color: #343434;
  font-size: 14px;
  box-shadow: 1px 10px 20px 0px rgba(90, 98, 180, 0.1);
  border-radius: 4px;
}
.panel-title {
  width: 100%;
  height: 69px;
  padding: 30px 0px 23px 33px;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}
.video-content {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 69px);
}
.panel-no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 138px);
  color: #666666;
}
.video-list {
  width: calc(100% + 50px);
  height: calc(100% - 50px);
  padding-left: 33px;
  overflow: auto;

  > div.video-list-content {
    width: 100%;
    height: 176px;
    margin-top: 24px;

    &:first-child {
      margin-top: 0px;
    }
  }
}
.video-clear {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  right: 30px;
  bottom: 0;
  height: 50px;
  background-color: #ffffff;
  text-align: right;

  span {
    margin-left: 2px;
    cursor: pointer;
  }

  .hover {
    display: none;
  }

  &:hover {
    .normal {
      display: none;
    }
    .hover {
      display: block;
    }
  }
}
</style>
